module.exports = __webpack_public_path__ + "static/media/4.607ff22d.png";